import { render, staticRenderFns } from "./ConferenciaReprovar.vue?vue&type=template&id=368c67f0"
import script from "./ConferenciaReprovar.vue?vue&type=script&lang=js"
export * from "./ConferenciaReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports